import React from "react";
import { connect } from "react-redux";

interface Props {
    id: string;
    name: string;
    labelText: string;
    country: string;
    selectCountry: (val: string) => void;
    required?: boolean;
    validate?: boolean | string;
    currentUser?: any;
}

function CountrySelect(props: Props) {
    const { id, labelText, required, validate } = props;
    return (
        <div className="from-group mb-3">
            <label htmlFor={id}>
                {labelText}
                {required ? <span className="text-danger">*</span> : ""}
            </label>
            {/* <CountryDropdown
                id={id}
                name={name}
                classes={`form-control mb-0 ${
                    validate === ""
                        ? ""
                        : validate
                        ? "is-valid"
                        : validate === false
                        ? "is-invalid"
                        : ""
                }`}
                valueType={"short"}
                value={country}
                onChange={(val: any) => {
                    selectCountry(val);
                }}
                whitelist={
                    currentUser.userType !== userType.SUPER_ADMIN &&
                    currentUser.userType !== userType.USER_MANAGER
                        ? currentUser.country
                        : undefined
                }
            /> */}
            {validate === "" && validate ? "" : <div className="invalid-feedback">Required</div>}
        </div>
    );
}

const mapStateToProps = (state: any) => {
    return {
        currentUser: state.users.currentUser,
    };
};
const mapDispatchToProps = (dispatch: any) => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(CountrySelect);
